<template>
  <div>
    <div>
      <el-button
        size="small"
        icon="el-icon-arrow-down"
        @click="handleOpenClick"
      >
        {{ placeholder }}
      </el-button>
      <slot name="extras-end" />
      <slot name="tips" />
    </div>
    <select-drawer :title="title" :maxWidth="width" :visible="selectVisible">
      <template slot="header">
        <div>
          <div class="select-footer">
            <el-button type="primary" @click="handleCancelClick" :size="size">
              {{ closeLabel }}
            </el-button>
          </div>
        </div>
      </template>
      <template slot="header-extra">
        <slot name="header-extra" />
      </template>
      <template slot="content">
        <el-card shadow="hover" :style="menuStyle">
          <template v-if="showMenu">
            <div class="config-box">
              <div class="config-wrap">
                <div class="config-left">
                  <height-view :offsetSize="120">
                    <slot name="menu" />
                  </height-view>
                </div>
                <div class="config-right">
                  <height-view :offsetSize="120">
                    <x-table
                      ref="list"
                      paginationLayout="total, sizes, prev, next, jumper"
                      actionFixed="right"
                      :listApi="listApi"
                      :emptyLabel="emptyLabel"
                      :filterMethod="filterMethod"
                      :handleFetchList="handleFetchList"
                      :handleMapList="handleMapList"
                      :fieldList="fieldList"
                      :defaultParams="defaultParams"
                      :defaultPageSize="defaultPageSize"
                      :paginationShow="paginationShow"
                      :paramList="paramList"
                      :actionWidth="150"
                    >
                      <template slot="row-info" slot-scope="scope">
                        <slot
                          name="row-info"
                          :row="scope.row"
                          :cancel="handleCancelClick"
                        />
                      </template>
                    </x-table>
                  </height-view>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <x-table
              ref="list"
              paginationLayout="total, sizes, prev, next, jumper"
              actionFixed="right"
              :listApi="listApi"
              :emptyLabel="emptyLabel"
              :filterMethod="filterMethod"
              :handleFetchList="handleFetchList"
              :handleMapList="handleMapList"
              :fieldList="fieldList"
              :defaultParams="defaultParams"
              :defaultPageSize="defaultPageSize"
              :paginationShow="paginationShow"
              :paramList="paramList"
              :actionWidth="150"
            >
              <template slot="row-info" slot-scope="scope">
                <slot
                  name="row-info"
                  :row="scope.row"
                  :cancel="handleCancelClick"
                />
              </template>
            </x-table>
          </template>
        </el-card>
      </template>
    </select-drawer>
  </div>
</template>

<style lang="less" scoped>
.config-box {
  padding: 10px 10px;

  .config-wrap {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    .config-left {
      width: var(--menu-width);
      min-height: 200px;
      margin-right: 20px;
    }

    .config-right {
      width: calc(100% - 20px - var(--menu-width));
      min-height: 200px;
    }
  }
}
</style>

<style lang="less" scoped>
.select-item {
  font-size: 14px;
}
.select-footer {
  margin-top: 10px;
  text-align: right;
}
</style>

<script>
import HeightView from './heightView.vue'
import selectDrawer from './selectDrawer.vue'

export default {
  components: {
    selectDrawer,
    HeightView
  },
  props: {
    size: {
      type: String,
      default: "small"
    },
    width: {
      type: Number,
      default: 600
    },
    title: {
      type: String,
      default: "请选择",
    },
    listApi: {
      type: String,
    },
    placeholder: {
      type: String,
      default: "请选择数据",
    },
    emptyLabel: {
      type: String,
      default: "暂无数据",
    },
    paramList: {
      type: Array,
      default: () => {
        return []
      }
    },
    fieldList: {
      type: Array,
      default: () => {
        return []
      }
    },
    filterMethod: {
      type: Function
    },
    handleMapList: {
      type: Function
    },
    handleFetchList: {
      type: Function
    },
    multipleable: {
      type: Boolean,
      default: false,
    },
    paginationShow: {
      type: Boolean,
      default: true,
    },
    closeLabel: {
      type: String,
      default: "确定",
    },
    valuePropName: {
      type: String,
      default: "guid"
    },
    defaultParams: {
      type: Object,
      default: () => {
        return {}
      }
    },
    defaultPageSize: {
      type: Number,
      default: 10
    },
    showMenu: {
      type: Boolean,
      default: false,
    },
    menuWidth: {
      type: Number,
      default: 160,
    },
  },
  computed: {
    menuStyle() {
      return {
        "--menu-width": `${this.menuWidth}px`,
      }
    },
  },
  data() {
    return {
      selectItem: null,
      selectVisible: false,
    };
  },
  methods: {
    hideDialog() {
      this.selectVisible = false;
    },
    showDialog() {
      this.selectVisible = true;
    },
    dispatch(componentName, eventName, params) {
      setTimeout(() => {
        try {
          var parent = this.$parent || this.$root;
          var name = parent.$options.componentName;
          while (parent && (!name || name !== componentName)) {
            parent = parent.$parent;
            if (parent) {
              name = parent.$options.componentName;
            }
          }
          if (parent) {
            parent.$emit.apply(parent, [eventName].concat(params));
          }
        } catch (error) { }
      }, 200);
    },
    handleCancelClick() {
      this.hideDialog();
    },
    handleOpenClick() {
      this.showDialog();
      this.$nextTick(() => {
        if (this.$refs.list) {
          this.$refs.list.refresh();
        }
      });
    },
  },
}
</script>